@import 'styles/mixins';
@import 'styles/variables';

.picker {
  display: flex;
  gap: 6px;
}

.hueSwatch {
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
  border-radius: 50%;
  @include transition;

  &.selected {
    .hueSwatchWell {
      box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.2), inset 0 0 0 4px var(--dark-40);
    }
  }
}

.hueSwatchWell {
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
  border-radius: 50%;
  background-color: var(--swatch-color);
  display: block;

  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.2), inset 0 0 0 2px var(--dark-20);
}

@media (min-width: $tabletPortraitMinWidth) {
  .picker {
    gap: 10px;
  }
}
